import React, { useState , useEffect} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from "react-router-dom";

import { signIn, checkedVerified } from '../../app/actions/authActions'; 
import { getDataSubscriptionPopUp  } from '../../app/actions/stripeActions'; 
import Title from '../../components/Title';
import Input from '../../components/Input';
import Button from '../../components/Button';
import AlertMessage from '../../components/AlertMessage';
import Subscription from '../../components/Subscription';
import { withAuthLayout } from '../../components/hocs/withAuthLayout';

import './styles.scss';

const Login = () => {
	const history = useHistory();
	const dispatch = useDispatch();
	const showAlert = useSelector((state) => state.ui.showAlert);
	const subscriptionPopup = useSelector((state) => state.ui.subscriptionPopup);
	const uid = useSelector((state) => state.firebase.auth.uid);
	const isVerified = useSelector((state) => state.auth.isVerified);
	const approved = useSelector((state) => state.auth.approved);

	const [state, setState] = useState({
		email: '',
		password: '',
	});

	const handleSubmit = (event) => {
		event.preventDefault();
		dispatch(signIn(state));
	};

	const handleChangeInput = (target) => {
		setState( (state)=> ({...state,[target.id]:target.value}))
	};

	const handleRedirect = (event) => {
		event.preventDefault();
		history.push(`/${event.target.name}`);
	};

	useEffect(()=>{
		uid && dispatch(checkedVerified(uid));
		dispatch(getDataSubscriptionPopUp())
		// eslint-disable-next-line react-hooks/exhaustive-deps
	},[]); 
	
	useEffect(() => {
		if(uid && isVerified && approved) {
			history.push('/');
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	},[uid,isVerified,approved]);

	return (
		subscriptionPopup ? (
			<Subscription />
		)
		:
		( <div className="auth__content">	
			<Title text={'Login'} isBig isBold/>
			<AlertMessage showAlert={showAlert}/>
			<form 
				className="auth__form"
				onSubmit={handleSubmit}
			>
				<Input 
					value={state.email}
					id='email'
					type='email' 
					label='email' 
					onChange={handleChangeInput}
					required 
				/>
				<Input 
					value={state.password}
					id='password'
					type='password' 
					label='password'
					onChange={handleChangeInput}
					required
				/>
				<div className="auth__btn">
					<Button text='Log in'/>
				</div>
			</form>
			<div className="auth__controls">
				<a 
					href="/"
					className="auth__controls-item"
					name="reset-password" 
					onClick={handleRedirect}
				>
					Forgot Password?
				</a>
				<a 
					href="/"
					className="auth__controls-item"
					name="sign-up" 
					onClick={handleRedirect}
				>
					Make a New Account
				</a>
			</div>
		</div>
		)
	);
};

export default withAuthLayout(Login);
